enum RouteEndpointsUsers {
  BASE_USERS = '/user-management',
  EDIT_USER = 'edit/:id',
  ADD_USER = 'add',
}

export default RouteEndpointsUsers;
